import React from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import type { AwardProps } from 'Components/widgets/tripadvisor-awards/TripAdvisorAwards';
import 'Components/widgets/tripadvisor-awards/TripAdvisorAwards';
import type { TripAdvisorRatingsProps } from 'Components/widgets/tripadvisor-ratings/TripAdvisorRatings';
import 'Components/widgets/tripadvisor-ratings/TripAdvisorRatings';
import type { ReviewProps } from 'Components/widgets/tripadvisor-reviews/TripAdvisorReviews';
import 'Components/widgets/tripadvisor-reviews/TripAdvisorReviews';
import { TripAdvisorLarge } from 'Components/widgets/tripadvisor-large/TripAdvisorLarge';
import { TripAdvisorNarrow } from 'Components/widgets/tripadvisor-narrow/TripAdvisorNarrow';
type Props = {
  awards?: Array<AwardProps>;
  awardsLabel?: string;
  ratings?: TripAdvisorRatingsProps;
  ratingsLabel?: string;
  reviews?: Array<ReviewProps>;
  reviewsLabel?: string;
};
export const TripAdvisor = (props: Props) => {
  const { isDesktop } = useResponsive();
  return isDesktop ? <TripAdvisorLarge {...props} /> : <TripAdvisorNarrow {...props} />;
};
